// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3mc4C","right":"styles_right__ysEHu"};